import { useEffect, useState } from 'react'

// Blob живёт в браузере до перезагрузки вкладки, если его object-URL не отозвать.
// Хук держит URL ровно столько, сколько смонтирован потребитель, и отзывает
// предыдущий при смене blob'а.
export function useObjectUrl(blob: Blob | null | undefined): string | null {
  const [url, setUrl] = useState<string | null>(null)

  useEffect(() => {
    if (!blob) {
      setUrl(null)
      return
    }
    const next = URL.createObjectURL(blob)
    setUrl(next)
    return () => {
      URL.revokeObjectURL(next)
      setUrl(null)
    }
  }, [blob])

  return url
}
